<template>
  <div class="mr-3">
    <button @click="scorePage" class="button">
      Score This Page {{ counter }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ScoreThisPage',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentCounter: 0,
      intervalId: null
    }
  },
  computed: {
    counter () {
      return this.currentCounter === 0 ? '' : `(${this.currentCounter})`
    }
  },
  methods: {
    startCountdown (total) {
      // Clear any existing interval
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }

      this.currentCounter = total ? Math.ceil(total / 17) : 20

      // Start a countdown
      this.intervalId = setInterval(() => {
        if (this.currentCounter > 0) {
          this.currentCounter -= 1
        } else {
          clearInterval(this.intervalId) // Stop the countdown at zero
          this.intervalId = null
        }
      }, 1000) // Update every second
    },
    async scorePage () {
      const query = await this.payload.d()
      const total = await this.payload.c()
      const { type, id } = this.payload
      this.startCountdown(total)
      await this.$network_utils.postEvent({
        event: 'score_resource_page',
        current_type: type,
        current_resource_id: id,
        data: query
      })
      this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
    }
  },
  beforeDestroy () {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }
}
</script>
